<template>
  <div class="card" style="margin-bottom: 10px;">
    <div class="cardBody">
      <div class="cardContent">
        <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <p class="cardTitleType1" style="margin: 0px">{{ tajukKad }}</p>
        </div>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: flex-start; align-items: flex-start;">
          <el-table
            :data="quotaTambahanArray"
            fit
            highlight-current-row
          >
            <el-table-column
              label="No."
              width="50" type="index">
            </el-table-column>
            <el-table-column
              prop="vehicleNumber"
              label="No. Kenderaan"
              min-width="160"
              :sortable="false">
              <template slot-scope="scope">
                <span style="word-break: break-word; font-weight: 500;">{{ scope.row.vehicleNumber ? scope.row.vehicleNumber : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quotaTambahanAmount"
              label="Kuota Tambahan (liter)"
              min-width="180"
              :sortable="false">
              <template slot-scope="scope">
                <!-- A record against a vehicle that is tidak layak, road-tax-expired, disekat or
                     never activated reads 0 in grey and is left out of the total below. The row
                     stays so staff can still see the record was imported. -->
                <span v-if="scope.row.quotaTambahanEligible === false" style="word-break: break-word; color: #909399;">0</span>
                <span v-else style="word-break: break-word;">{{ scope.row.quotaTambahanAmount | formatNumber }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; flex-direction: row; width: 100%; justify-content: flex-end; align-items: center; margin-top: 10px;">
            <span style="font-weight: 500;">Jumlah Kuota Tambahan: {{ totalQuotaTambahan }} liter</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuotaTambahanRecordsDiesel',
  props: {
    tajukKad: {
      type: String
    },
    quotaTambahanArray: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    formatNumber(val) {
      if (val !== null && val !== undefined) {
        return val.toLocaleString('en')
      }
      return '-'
    }
  },
  computed: {
    totalQuotaTambahan() {
      return Number(this.quotaTambahanArray.reduce((acc, item) => {
        // Records the caller flagged ineligible contribute nothing. An undefined flag counts as
        // eligible, so a caller that does not annotate keeps the previous behaviour.
        if (item.quotaTambahanEligible === false) {
          return acc
        }
        const value = Number(item.quotaTambahanAmount) ? Number(item.quotaTambahanAmount) : 0
        return acc + value
      }, 0)).toLocaleString('en')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mydiesel/components/QuotaTambahanRecordsDiesel.vue